import { useCallback, useEffect, useState } from "react";

import { useSubscribe } from "data/messages/hooks";

function useSubscribeToChangePlan({ onPlanChanged }) {
  const [isCompleted, setCompleted] = useState(false);

  useEffect(() => {
    if (isCompleted) {
      onPlanChanged();
      setCompleted(false);
    }
  }, [isCompleted, onPlanChanged]);

  useSubscribe(
    "changePlanCompleted",
    useCallback((planChangeSet) => {
      if (planChangeSet && planChangeSet.values().next().value)
        setCompleted(true);
    }, [])
  );
}

export default useSubscribeToChangePlan;
